<template>
    <el-form label-position="top" :rules="rules" ref="ruleFormRef" :model="values" @submit.prevent>
        <el-radio-group v-model="values.insType">
            <el-radio-button value="p" :disabled="disP">Fiziki şəxs</el-radio-button>
            <el-radio-button value="c" :disabled="disC">Hüquqi şəxs</el-radio-button>
        </el-radio-group>
        <br><br>
        <div class="row ps-5 pe-5">
            <div class="col-sm-5">
                <el-radio-group v-model="values.personType">
                    <el-radio value="a" size="small">Azərbaycan vətəndaşı</el-radio>
                    <el-radio value="f" size="small">Xarici Vətəndaşı</el-radio>
                </el-radio-group>
                <el-form-item label="Axtar" v-if="values.personType == 'a'" label-position="top">
                    <el-input v-model="values.finSearch" class="w-50" />
                    &nbsp;&nbsp;
                    <soft-button class="mb-0" @click="Search()" color="success"
                        style="padding: 0.5rem 1.2rem  !important;">ASAN</soft-button>
                </el-form-item>
            </div>
        </div>
        <div class="row ps-5 pe-5">
            <div class="col-sm-5">
                <el-form-item label="FİN" v-if="values.insType == 'p'" class="mt-1" label-position="top">
                    <el-input v-model="values.fin" />
                </el-form-item>
                <el-form-item label="VÖEN" v-if="values.insType == 'c'" class="mt-1" label-position="top">
                    <el-input v-model="values.voen" />
                </el-form-item>
                <el-form-item label="Soyadı" v-if="values.insType == 'p'" class="mt-1" label-position="top">
                    <el-input v-model="values.suraname" />
                </el-form-item>
                <el-form-item label="Adı" class="mt-1" label-position="top">
                    <el-input v-model="values.name" />
                </el-form-item>
                <el-form-item label="Atasının adı" v-if="values.insType == 'p'" class="mt-1" label-position="top">
                    <el-input v-model="values.lastname" />
                </el-form-item>
                <el-form-item label="Cinsi" v-if="values.insType == 'p'" class="mt-1" label-position="top">
                    <el-select v-model="values.sex" collapse-tags collapse-tags-tooltip placeholder="Seçin">
                        <el-option label="Kişi" :value="0" />
                        <el-option label="Qadın" :value="1" />
                    </el-select>
                </el-form-item>
                <el-form-item label="Doğum tarixi" v-if="values.insType == 'p'" class="mt-1" label-position="top">
                    <el-date-picker format="DD.MM.YYYY" v-model="values.generalDate" class="w-100" type="date"
                        placeholder="Pick a day" />
                </el-form-item>
                <el-form-item label="Ünvan" class="mt-1" label-position="top">
                    <el-input v-model="values.address" />
                </el-form-item>
            </div>
            <div class="col-sm-2"></div>
            <div class="col-sm-5">
                <el-form-item label="Telefon (Mobil)" class="mt-1" label-position="top">
                    <el-input v-model="values.phone" type="Number" />
                </el-form-item>
                <el-form-item label="Telefon (Ev)" v-if="values.insType == 'p'" class="mt-1" label-position="top">
                    <el-input v-model="values.phonehome" />
                </el-form-item>
                <el-form-item label="Telefon (Ofis)" v-if="values.insType == 'p'" class="mt-1" label-position="top">
                    <el-input v-model="values.phoneoffice" />
                </el-form-item>
                <el-form-item label="Email" v-if="values.insType == 'p'" class="mt-1" label-position="top">
                    <el-input v-model="values.mail" />
                </el-form-item>
            </div>
        </div>
        <el-affix position="bottom" :offset="5">
            <div class="row dialog-btn">
                <div>
                    <soft-button @click="SubmitForm()" color="success">
                        {{ !this.editing ? 'Daxil et' : 'Qəbul et' }}</soft-button>
                    &nbsp;&nbsp;&nbsp;
                    <soft-button @click="this.$emit('close-dialog')" color="secondary">Imtina</soft-button>
                </div>
            </div>
        </el-affix>
    </el-form>
</template>
<script>
import SoftButton from "@/components/SoftButton.vue";
export default {
    components: {
        SoftButton
    },
    props: {
        editing: Boolean,
        object: Object,
        onlyP: { type: Boolean, default: false },
        onlyC: { type: Boolean, default: false },
    },
    data() {
        return {
            values: { insType: 'p', personType: 'a' },
            disC: false,
            disP: false,
        }
    },
    methods: {
        SubmitForm() {
            this.$refs.ruleFormRef.validate(valid => {
                if (valid) {
                    this.$emit('chose-client')
                }
            })
        },
        Search() {
            this.values = {
                insType: this.values.insType,
                personType: this.values.personType,
                finSearch: this.values.finSearch,
                fin: this.values.finSearch != null ? this.values.finSearch : '78TRE4Q',
                voen: this.values.finSearch != null ? this.values.finSearch : '8884800048785',
                suraname: "Məmmədov",
                name: this.values.insType == 'p' ? "Əli" : "Xəzər Holdinq MMC",
                lastname: "İlham",
                sex: 0,
                generalDate: "1990-05-14",
                address: "Bakı şəhəri, Nərimanov r., Ağa Nemətulla küç., ev 25",
                phone: "0501234567",
                phonehome: "0123456789",
                phoneoffice: "0129876543",
                mail: "ali.mammadov@example.com"
            }
        }
    },
    mounted() {
        if (this.onlyP) {
            this.disC = true
            this.values.insType = 'p'
        } else if (this.onlyC){
            this.disP = true
            this.values.insType = 'c'
        }
    },
}
</script>
<style lang="scss">
.el-form--default.el-form--label-top {
    .el-form-item {
        .el-form-item__label {
            margin-bottom: 4px !important;
        }
    }
}

label,
.form-label {
    margin-left: 0 !important;
}
</style>